export enum DistributionTypes {
  deterministic = 'deterministic',
  normal = 'normal',
  uniform = 'uniform',
  triangular = 'triangular',
  lognormal = 'lognormal',
  truncatednormal = 'truncatednormal',
  truncatedlognormal = 'truncatedlognormal'
}

export interface IDistribution {
  id: number | null,
  name: string,
  max: number | null,
  mean: number | null,
  min: number | null,
  mode: number | null,
  std: number | null,
  location: number | null,
  shape: number | null,
  prob: DistributionTypes,
}
